module.exports = __webpack_public_path__ + "img/HOME.ce6b88f3.png";